import { CustomIconButtonColor } from '../../UiComponentsLibrary/CustomIconButton/constants/CustomIconButtonColor';
import { CustomButtonColor } from '../../UiComponentsLibrary/CustomButton/constants/CustomButtonColor';
import { pencil, trash, search, refresh } from '@amzn/storm-ui-icons';

export const userManagementCardActions = {
  activeUsers: {
    text: 'active-users',
    backgroundColor: CustomButtonColor.activeUsers,
  },
  createUser: {
    text: 'create-user',
    backgroundColor: CustomButtonColor.createUser,
  },
  deletedUsers: {
    text: 'deleted-users',
    backgroundColor: CustomButtonColor.deletedUsers,
  },
};

export const dataTableActions = {
  viewUser: {
    icon: search,
    backgroundColor: CustomIconButtonColor.search,
  },
  editUser: {
    icon: pencil,
    backgroundColor: CustomIconButtonColor.pencil,
  },
  deleteUser: {
    icon: trash,
    backgroundColor: CustomIconButtonColor.delete,
  },
  restoreUser: {
    icon: refresh,
    backgroundColor: CustomIconButtonColor.refresh,
  },
};
